import { jsx as _jsx } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgShoppingCart = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 21,
  viewBox: "0 0 19 21",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "#1B1918",
    d: "M5.963 20.149c-.459 0-.848-.162-1.166-.484a1.609 1.609 0 0 1-.479-1.175c0-.46.16-.851.479-1.171.319-.32.707-.48 1.164-.48.457 0 .848.16 1.173.483.325.323.488.714.488 1.175 0 .46-.161.851-.484 1.172-.322.32-.714.48-1.175.48m9.693 0c-.46 0-.848-.162-1.167-.484a1.609 1.609 0 0 1-.479-1.175c0-.46.16-.851.48-1.171.318-.32.706-.48 1.163-.48.457 0 .848.16 1.173.483.326.323.488.714.488 1.175 0 .46-.16.851-.483 1.172-.323.32-.715.48-1.175.48M4.612 4.097l2.704 5.647h7.095l2.955-5.377c.038-.07.041-.133.01-.188-.033-.054-.087-.082-.164-.082zm1.233 10.95c-.642 0-1.112-.24-1.41-.722-.298-.481-.3-.992-.006-1.534l1.548-2.809-3.733-7.874H.964a.57.57 0 0 1-.428-.184.626.626 0 0 1-.175-.45.612.612 0 0 1 .628-.623h1.566a.77.77 0 0 1 .708.443l.724 1.547h13.875c.501 0 .841.167 1.02.501.179.335.155.7-.073 1.098l-3.119 5.645c-.157.27-.368.49-.633.66-.265.17-.554.255-.868.255h-7.36l-1.307 2.406c-.047.077-.047.16-.002.25.046.09.117.135.214.135H16.71c.168 0 .31.062.428.187a.633.633 0 0 1 .175.45.612.612 0 0 1-.628.62z"
  })
});
export default SvgShoppingCart;